import { Component } from 'react';
import classNames from 'classnames';
import React from 'react';
import PrepareStyles from './Prepare.cssmodule.less';
import _cloneDeep from 'lodash/cloneDeep';

class ObjectsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contents: this.props.contents.filter(content => {
                return content !== null;
            }).map(data => {
                const content = _cloneDeep(data);
                content.isOpen = false;
                return content;
            }),
        };
        this.toggleClass = this.toggleClass.bind(this);
    }

    toggleClass(e, index) {
        e.preventDefault();
        const contents = [...this.state.contents];
        contents[index] = { ...contents[index], isOpen: !contents[index].isOpen };
        this.setState({ contents });
    }

    renderContents() {
        return this.state.contents.map((content, index) => {
            if (!content.media || content.media.category !== 'IMAGE') {
                return;
            }
            return <li key={index} className={classNames(PrepareStyles.list, { [PrepareStyles.on]: content.isOpen })}
                       onClick={(e) => this.toggleClass(e, index)}>
                <div className={PrepareStyles.card}>
                    <span className={PrepareStyles.ico}>
                        1번 카드 보기
                    </span>
                </div>
                <div className={PrepareStyles.result_box}>
                    <div className={PrepareStyles.card_thmb}>
                        <img src={content.media.content}/>
                    </div>
                    <p className={PrepareStyles.card_sjt}>{content.name}</p>
                </div>
            </li>;
        });
    }

    render() {
        return (
            /* 오브젝트 step2 = prepare_step2 클래스 추가 */
            <div>
                <div className={PrepareStyles.intro_top}>
                    <div className={PrepareStyles.intro_inner}>
                        <div className={`${PrepareStyles.cell} ${PrepareStyles.prepare_ready}`}>
                            <div className={PrepareStyles.thmb_group}>
                                <span className={PrepareStyles.thmb}>&nbsp;</span>
                                <strong className={PrepareStyles.title}>학습준비</strong>
                            </div>
                            <ul className={PrepareStyles.prepare_step_list}>
                                <li>
                                    <em className={PrepareStyles.item_no}>1</em>
                                    목표 작품 보기
                                </li>
                                <li className={PrepareStyles.active}>
                                    <em className={PrepareStyles.item_no}>2</em>
                                    오브젝트
                                </li>
                                <li>
                                    <em className={PrepareStyles.item_no}>3</em>
                                    문제해결
                                </li>
                            </ul>
                            작품을 만들기 위해 필요한 오브젝트에는 무엇이 있을까요?
                        </div>
                    </div>
                </div>
                <div className={PrepareStyles.body}>
                    <ul className={PrepareStyles.card_list}>
                        {/* list 클래스가 클릭되면 on 클래스 추가 */}
                        {this.renderContents()}
                    </ul>
                </div>
            </div>
        );
    }
}

export default ObjectsList;



// WEBPACK FOOTER //
// ./components/Curriculum/Prepare/ObjectsList.js